import React from 'react';

export type BadgeTone = 'green' | 'amber' | 'red' | 'blue' | 'purple' | 'gray';

const TONE_CLASSES: Record<BadgeTone, string> = {
  green: 'bg-green-50 text-green-700 ring-green-600/20',
  amber: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  red: 'bg-red-50 text-red-700 ring-red-600/20',
  blue: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  purple: 'bg-purple-50 text-purple-700 ring-purple-600/20',
  gray: 'bg-gray-100 text-gray-600 ring-gray-500/15',
};

const Badge: React.FC<{ tone: BadgeTone; children: React.ReactNode; className?: string }> = ({ tone, children, className }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium capitalize ring-1 ring-inset whitespace-nowrap ${TONE_CLASSES[tone]} ${className ?? ''}`}>
    {children}
  </span>
);

export default Badge;
